import { promiseToResult } from '../../utils'
import AxiosInstance, { AxiosInstanceType } from '../../core/api/axiosinstance'

const getApplicationPing = () => {
  return promiseToResult(AxiosInstance().get(
    '/application/__check/ping',
  ))
}

const getProjectsPing = () => {
  return promiseToResult(AxiosInstance().get(
    '/projects/__check/ping',
  ))
}

export interface PostFileReq {
  filename?: string
  file: File
}
export interface PostFileRes {
  id: number
  contentType: string
  path: string
  size: number
  url: string
}
const postFiles = (data: PostFileReq) => {
  const form = new FormData()
  form.append('filename', data.filename || data.file.name)
  form.append('file', data.file)

  return promiseToResult(
    AxiosInstance(AxiosInstanceType.FORMDATA).post<PostFileRes>(
      '/application/files',
      form,
    ),
  )
}

export const AppAPI = {
  getApplicationPing,
  getProjectsPing,
  postFiles,
}
